import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Switch, Redirect, Route, } from 'react-router-dom';
import List from './List';
import Create from './Create';
import NotFound from '../../../copms/NotFound/NotFound';

class CreateTransferConvertation extends Component {
    render() {
        let { updateAppState, updateDashboardState, alertState, logout } = this.props;

        return (
            <Switch>
                <Redirect exact from="/dashboard/guarantees" to="/dashboard/guarantees/list" />
                <Redirect exact from="/dashboard/guarantees/list" to="/dashboard/guarantees/list/active" />
                {localStorage.getItem('compId') && <>
                    <Route path="/dashboard/guarantees/create/:orderId?" render={(routeProps) => <Create logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                    <Route path={["/dashboard/guarantees/list/active", "/dashboard/guarantees/list/orders", "/dashboard/guarantees/list/refusals"]} render={(routeProps) => <List logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                </>}
                <Route render={(routeProps) => (<NotFound />)} />
            </Switch>
        )
    }
}

export default translate("translation")(CreateTransferConvertation);